import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { IEnterprisePayments } from '@efex-services/payments/types';
import PaymentsSvc from '@efex-services/payments';
import { LoadState } from '@pages/store/types';

type PayableState = LoadState<IEnterprisePayments>;
interface IFetchPaymentsParams {
  enterpriseId: number;
  params?: {
    search?: string;
    status?: string;
    page?: number;
    dateFrom?: string;
    dateTo?: string;
  };
}

export const initialState: PayableState = {
  error: '',
  loading: false,
  data: null,
};

const fetchPayments = createAsyncThunk(
  'fetchPayments',
  async (params: IFetchPaymentsParams) =>
    PaymentsSvc.getPayments({
      enterpriseId: params.enterpriseId,
      search: params?.params?.search,
      page: params?.params?.page,
      dateFrom: params?.params?.dateFrom,
      dateTo: params?.params?.dateTo,
      status: params?.params?.status,
    })
);

export const paymentsStatus = createSlice({
  name: 'fetchPayments',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchPayments.pending, (state) => {
      state.loading = true;
      state.error = '';
    });
    builder.addCase(
      fetchPayments.fulfilled,
      (state, { payload: paymentsResponse }) => {
        state.loading = false;
        state.data = paymentsResponse;
        state.error = '';
      }
    );

    builder.addCase(fetchPayments.rejected, (state) => {
      state.loading = false;
      state.data = null;
      state.error = 'ERROR';
    });
  },
});

export { fetchPayments };
export default paymentsStatus.reducer;
